import * as React from 'react';

import TileStandardContentDetails from '../content/details/TileStandardContentDetails';
import TileStandardCarousel from '../carousel/TileStandardCarousel';

import './tile-standard-content-channels.scss';

import type { Channel } from 'types';

type Props = {
  activeChannel: Channel
};

const TileStandardContentChannelsYoutube = React.memo<Props>((
  {
    activeChannel
  }: Props
): JSX.Element => (
  <div className="tile-standard-content-channels">
    <div className="tile-standard-content-channels__details">
      <TileStandardContentDetails
        activeChannel={activeChannel}
      />
    </div>
    <div className="tile-standard-content-channels__carousel">
      <TileStandardCarousel
        type="standard"
      />
    </div>
  </div>
));

export default TileStandardContentChannelsYoutube;
